/**
 * Returns the given date in YYYY-MMM-DD format (e.g., 1972-Sep-06)
 * Use this with timestamps where the time matters and we want to adjust to the local timezone
 * @param date
 */
export function formatDateWithTimestamp(date: Date): string {
    const year = date.getFullYear();
    const month = date.toLocaleString("default", { month: "short" });
    const day = date.getDate();

    return `${year}-${month}-${day}`;
}

/**
 * Returns the given date in YYYY-MMM-DD format (e.g., 1972-Sep-06)
 * Use this with dates from datepickers where the time doesn't matter and we don't want to adjust to the local timezone
 * @param date
 */
export function formatDatepickerDate(date: Date): string {
    const year = date.getUTCFullYear();
    const month = date.toLocaleString("default", { month: "short", timeZone: "UTC" });
    const day = date.getUTCDate();

    return `${year}-${month}-${day}`;
}

export function formatDateTime(date: Date): string {
    const time = date.toLocaleTimeString();

    return formatDateWithTimestamp(date) + `, ${time}`;
}

/**
 * A helper method for parsing a UTC date
 */
export function parseDateAsUTC(s: string): Date {
    return new Date(s + "Z");
}

// Based on https://github.com/LiosK/UUID.js/blob/master/src/uuid.js
// Generate a v4 UUID
export function generateUUID() {
    const rand = _getRandomInt,
        hex = _hexAligner;
    return (
        hex(rand(32), 8) + // time_low
        "-" +
        hex(rand(16), 4) + // time_mid
        "-" +
        hex(0x4000 | rand(12), 4) + // time_hi_and_version
        "-" +
        hex(0x8000 | rand(14), 4) + // clock_seq_hi_and_reserved clock_seq_low
        "-" +
        hex(rand(48), 12)
    ); // node
}

// Helper functions for generateUUID
// Gets random nonnegative int less than 2 ** num
function _getRandomInt(num: number) {
    if (num < 0 || num > 53) {
        return NaN;
    }
    const n = 0 | (Math.random() * 0x40000000); // 1 << 30
    return num > 30 ? n + (0 | (Math.random() * (1 << (num - 30)))) * 0x40000000 : n >>> (30 - num);
}

// Get a hex string of num with the given length
function _hexAligner(num: number, length: number) {
    let str = num.toString(16),
        i = length - str.length,
        z = "0";

    // Prepend zeroes until the string is the desired length
    for (; i > 0; i >>>= 1, z += z) {
        if (i & 1) {
            str = z + str;
        }
    }
    return str;
}
